import { GridSortModel } from '@mui/x-data-grid-pro';
import { FIELD_TO_SORT_CONFIG } from 'shared/domain/issue/mapping/toOut/issueFieldMappingConfig';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import { SortingOrder, SORT_TYPE } from 'shared/filter/sort/types';
import { SortData } from 'shared/filter/types';
import { PathToFieldMap } from './types';

export const DEFAULT_SORT: SortData = {
  key: IssueFieldNames.modificationDate,
  path: IssueFieldNames.modificationDate,
  type: SORT_TYPE.NUMBERS,
  order: SortingOrder.desc,
};

const PATH_TO_FIELD: PathToFieldMap = {};

for (const [field, config] of Object.entries(FIELD_TO_SORT_CONFIG)) {
  PATH_TO_FIELD[config.path] = field;
}

function isSortingOrder(value: unknown): value is SortingOrder {
  return value === SortingOrder.asc || value === SortingOrder.desc;
}

export function gridSortModelToSortData(
  model: GridSortModel
): SortData | undefined {
  if (!model.length || !model[0].sort) {
    return undefined;
  }

  // Intentionally use only the first sort item; issue filtering supports single-sort only.
  const item = model[0];
  const config = FIELD_TO_SORT_CONFIG[item.field];

  if (!config) {
    return undefined;
  }

  if (!isSortingOrder(item.sort)) {
    return undefined;
  }

  return {
    key: item.field,
    path: config.path,
    type: config.type,
    order: item.sort,
  };
}

export function sortDataToGridSortModel(
  sortData?: SortData
): GridSortModel {
  if (!sortData) {
    return [];
  }

  const field = PATH_TO_FIELD[sortData.path] || sortData.key;

  if (!FIELD_TO_SORT_CONFIG[field]) {
    return [];
  }

  return [
    {
      field,
      sort: sortData.order,
    },
  ];
}
